import { render, staticRenderFns } from "./ResourceDisplay.vue?vue&type=template&id=71bfb3d0&"
import script from "./ResourceDisplay.vue?vue&type=script&lang=js&"
export * from "./ResourceDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDisplay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResourceDisplay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
